<glxy-form-field bottomSpacing="none" [disabled]="editDisabled">
  <input
    [disabled]="editDisabled"
    ng-model-options="{ debounce: 200 }"
    [(ngModel)]="autocompleteInput"
    type="text"
    #addresstext
  />
</glxy-form-field>
